export const horses = {
  noneFound: 'Geen paarden gevonden',
  nav: {
    stallion: 'Hengsten',
    stud: 'Dekhengsten',
    mare: 'Merries',
    surrogate: 'Draagmoeders',
  },
};
